import { render, staticRenderFns } from "./BaseAuthenticationPopup.vue?vue&type=template&id=25744ae0"
import script from "./BaseAuthenticationPopup.vue?vue&type=script&lang=js"
export * from "./BaseAuthenticationPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('25744ae0')) {
      api.createRecord('25744ae0', component.options)
    } else {
      api.reload('25744ae0', component.options)
    }
    module.hot.accept("./BaseAuthenticationPopup.vue?vue&type=template&id=25744ae0", function () {
      api.rerender('25744ae0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/global/BaseAuthenticationPopup.vue"
export default component.exports